import { cx } from "../../lib/cx.js";
/* empty css              */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/StatusDot/StatusDot.tsx
/** A small status dot with its label. */
function StatusDot({ tone = "neutral", size = "sm", className, children, ...rest }) {
	const labelled = children !== void 0 && children !== null;
	return /* @__PURE__ */ jsxs("span", {
		className: cx("ds-status-dot", `ds-status-dot--${tone}`, `ds-status-dot--${size}`, className),
		...labelled ? {} : { role: "img" },
		...rest,
		children: [/* @__PURE__ */ jsx("span", {
			className: "ds-status-dot__dot",
			"aria-hidden": "true"
		}), labelled && /* @__PURE__ */ jsx("span", {
			className: "ds-status-dot__label",
			children
		})]
	});
}
//#endregion
export { StatusDot };

//# sourceMappingURL=StatusDot.js.map